import PageTemplate from '@root/joinroot.com/src/components/pages/page-template';
import ProductAvailabilityMapSection from '@root/joinroot.com/src/components/product-availability-map/product-availability-map-section';
import PropTypes from '@root/vendor/prop-types';

export default function ProductAvailabilityMapSpikePage({ location }) {
  return (
    <PageTemplate
      analyticsContext={''}
      deIndexPage={true}
      includeHotjar={false}
      includeOptimizely={false}
      isDarkMode={false}
      isStickyFooterDisabled={true}
      location={location}
      pageCanonical={''}
      pageDescription={''}
      pageTitle={'Product availability map spike'}
    >
      <ProductAvailabilityMapSection />
    </PageTemplate>
  );
}

ProductAvailabilityMapSpikePage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }.isRequired),
};
